import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksPhotos(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		dtConfig[ModulesMap.DONE_WORKS_PHOTOS].getDoneWorksPhotos,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksPhotoPreview(companyId, doneWorkId, photoId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		dtConfig[ModulesMap.DONE_WORKS_PHOTOS].getDoneWorksPhotoPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				photoId,
			},
		},
	)
}
function getDoneWorksPhotoPopup(companyId, doneWorkId, photoId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		dtConfig[ModulesMap.DONE_WORKS_PHOTOS].getDoneWorksPhotoPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				photoId,
			},
		},
	)
}

function createDoneWorksPhoto(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_PHOTOS,dtConfig[ModulesMap.DONE_WORKS_PHOTOS].createDoneWorksPhoto, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksPhoto(companyId, doneWorkId, photoId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_PHOTOS,dtConfig[ModulesMap.DONE_WORKS_PHOTOS].getDoneWorksPhoto, {
		urlParams: {
			companyId,
			doneWorkId,
			photoId,
		},
	})
}

function patchDoneWorksPhoto(companyId, doneWorkId, photoId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_PHOTOS,dtConfig[ModulesMap.DONE_WORKS_PHOTOS].patchDoneWorksPhoto, {
		urlParams: {
			companyId,
			doneWorkId,
			photoId,
		},
		...data,
	})
}

function putDoneWorksPhoto(companyId, doneWorkId, photoId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_PHOTOS,dtConfig[ModulesMap.DONE_WORKS_PHOTOS].putDoneWorksPhoto, {
		urlParams: {
			companyId,
			doneWorkId,
			photoId,
		},
		...data,
	})
}

function deleteDoneWorksPhoto(companyId, doneWorkId, photoId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_PHOTOS,dtConfig[ModulesMap.DONE_WORKS_PHOTOS].deleteDoneWorksPhoto, {
		urlParams: {
			companyId,
			doneWorkId,
			photoId,
		},
	})
}

export default {
	getDoneWorksPhotos,
	getDoneWorksPhotoPopup,
	getDoneWorksPhotoPreview,
	getDoneWorksPhoto,
	patchDoneWorksPhoto,
	putDoneWorksPhoto,
	createDoneWorksPhoto,
	deleteDoneWorksPhoto,
}
